import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@/assets/styles/dashboard.css'

import { mask } from 'vue-the-mask'

const app = createApp(App)

app.directive('mask', mask)

app
    .use(router)
    .mount('#app')

router.afterEach(() => {
  document.title = 'On Bet Sports'
})
